import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ApplepayIcon = (props) => {
    return (
        <Icon viewBox="0 0 41 27" cursor="pointer" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.25 0.421997H38.75C39.4882 0.421997 40.082 1.02747 40.082 1.77356V25.2267C40.082 25.9728 39.4882 26.5782 38.75 26.5782H2.25C1.51172 26.5782 0.917969 25.9728 0.917969 25.2267V1.77356C0.917969 1.02747 1.51172 0.421997 2.25 0.421997Z"
                fill="white"
                stroke="white"
                strokeWidth="0.838525"
            />
            <path
                d="M11.1643 9.08606C11.5042 8.65637 11.7307 8.07825 11.6721 7.4845C11.1761 7.51184 10.5745 7.82043 10.2229 8.25012C9.91043 8.61731 9.63308 9.21887 9.7034 9.78528C10.2581 9.83606 10.8128 9.50403 11.1643 9.08606Z"
                fill="currnetColor"
            />
            <path
                d="M11.664 9.89468C10.8593 9.8478 10.1718 10.3634 9.78897 10.3634C9.40225 10.3634 8.81241 9.92202 8.17178 9.93374C7.34366 9.94546 6.57022 10.422 6.15225 11.1837C5.28506 12.7033 5.92178 14.9572 6.76553 16.1955C7.17569 16.8087 7.66788 17.4845 8.31631 17.4611C8.9335 17.4337 9.17178 17.0548 9.91788 17.0548C10.664 17.0548 10.8827 17.4611 11.5312 17.4455C12.2069 17.4337 12.6288 16.8361 13.039 16.2228C13.5077 15.5236 13.6991 14.8478 13.7108 14.8126C13.6991 14.8009 12.4101 14.297 12.3983 12.7892C12.3866 11.5275 13.4101 10.9259 13.4608 10.8869C12.8827 10.0197 11.9804 9.92202 11.664 9.89468Z"
                fill="currnetColor"
            />
            <path
                d="M19.7109 8.18762C21.4648 8.18762 22.6836 9.41809 22.6836 11.2072C22.6836 13.004 21.4375 14.2423 19.668 14.2423H17.7266V17.3829H16.3203V8.18762H19.7109ZM17.7266 13.0431H19.3359C20.5547 13.0431 21.25 12.3751 21.25 11.215C21.25 10.0548 20.5547 9.39075 19.3398 9.39075H17.7266V13.0431Z"
                fill="currnetColor"
            />
            <path
                d="M23.0352 15.4767C23.0352 14.3009 23.918 13.6251 25.5469 13.5236L27.293 13.4142V12.9025C27.293 12.1564 26.8086 11.7501 25.9531 11.7501C25.2461 11.7501 24.7305 12.1212 24.625 12.6876H23.3594C23.3984 11.4962 24.5 10.629 25.9883 10.629C27.5938 10.629 28.6406 11.4806 28.6406 12.8087V17.3829H27.3438V16.2814H27.3125C26.9414 17.0001 26.1289 17.4532 25.2461 17.4532C23.9414 17.4532 23.0352 16.6642 23.0352 15.4767ZM27.293 14.8868V14.3673L25.7344 14.4728C24.8555 14.5275 24.3984 14.8595 24.3984 15.4415C24.3984 16.0001 24.875 16.3634 25.6211 16.3634C26.5703 16.3634 27.293 15.7462 27.293 14.8868Z"
                fill="currnetColor"
            />
            <path
                d="M29.832 19.8439V18.7423C29.918 18.754 30.1328 18.7657 30.2461 18.7657C30.8633 18.7657 31.2148 18.5001 31.4297 17.8087L31.5547 17.4025L29.1797 10.7111H30.6445L32.3008 16.1407H32.332L33.9844 10.7111H35.4102L32.9492 17.7384C32.3867 19.3517 31.7422 19.8829 30.375 19.8829C30.2695 19.8829 29.9258 19.8673 29.832 19.8439Z"
                fill="currnetColor"
            />
        </Icon>
    )
}

ApplepayIcon.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
}

export default ApplepayIcon
